import ActionTypes from '../constants/ActionTypes';
import { authHeader } from '../helpers';
import api from '../constants/api';
import { postApi } from '../helpers/http';

export const requestAIAssistants = (message) => ({
  type: ActionTypes.REQUEST_AI_ASSISTANT,
  message: message,
  receivedAt: Date.now()
})

export const receiveAIAssistants = (json) => ({
  type: ActionTypes.RECEIVE_AI_ASSISTANT,
  message: json.data,
  receivedAt: Date.now()
})

const doFetchAIAssistants = (newMessage, replaceMessage) => async dispatch => {
  dispatch(requestAIAssistants(replaceMessage));

  const data = {
    process_type: "chat_with_ai",
    message: newMessage,
  };

  try {
    const json = await postApi(data);
    console.log('Success:', json);
    if (json.statusCode === 200) {
      dispatch(receiveAIAssistants(json))
    } else {
      dispatch(receiveAIAssistants({data: json.data.message}))
    }
  } catch (error) {
    console.error('Error:', error);
    dispatch(receiveAIAssistants({data: '[エラー]'}));
  };
  // console.log('fetch:', data);
  // return fetch(api.url, {
  //   method: 'POST',
  //   headers: authHeader(),
  //   body: JSON.stringify(data),
  // })
  // .then(response => response.json())
  // .then(json => {
  //   console.log('Success:', json);
  //   if (json.statusCode === 200) {
  //     dispatch(receiveAIAssistants(json))
  //   } else {
  //     dispatch(receiveAIAssistants({data: json.data.message}))
  //   }
    
  // })
  // .catch((error) => {
  //   console.error('Error:', error);
  //   dispatch(receiveAIAssistants({data: '[エラー]'}))
  // });   
}

export const fetchAIAssistants = (newMessage, replaceMessage) => (dispatch, getState) => {
  return dispatch(doFetchAIAssistants(newMessage, replaceMessage));
}